/**
 * Web Vitals 수집 및 Sentry로 전송
 * GTM dataLayer 사용하지 않음
 */
export function initWebVitals() {
  try {
    if (typeof window === 'undefined' || !window.webVitals) {
      console.warn('[Web Vitals] CDN이 로드되지 않았습니다');
      return;
    }

    const { onCLS, onFCP, onFID, onLCP, onINP } = window.webVitals;

    // Sentry로 직접 전송
    const sendToSentry = metric => {
      try {
        if (window.Sentry && window.Sentry.captureMessage) {
          window.Sentry.captureMessage(`Web Vital: ${metric.name}`, {
            level: 'info',
            tags: {
              vital: metric.name,
            },
            contexts: {
              webVitals: {
                name: metric.name,
                value: metric.value,
                rating: metric.rating, // good, needs-improvement, poor
                delta: metric.delta,
                id: metric.id,
              },
            },
          });
        }

        // 개발 환경에서는 콘솔 로그
        if (process.env.NODE_ENV !== 'production') {
          console.log(`[Web Vitals] ${metric.name}:`, {
            value: metric.value,
            rating: metric.rating,
          });
        }
      } catch (e) {
        // no-op
      }
    };

    onCLS && onCLS(sendToSentry);
    onFCP && onFCP(sendToSentry);
    onFID && onFID(sendToSentry);
    onLCP && onLCP(sendToSentry);
    onINP && onINP(sendToSentry);

    console.log('[Web Vitals] 초기화 완료 - Sentry로 전송');
  } catch (e) {
    console.error('[Web Vitals] 초기화 실패:', e);
  }
}
